import { useQuery } from "@tanstack/vue-query";

import optionsApiService from "@/services/modules/options";

export const OPTIONS_QUERY_KEYS = {
  CHECKOUT: ["options", "checkout"],
} as const;

export const useCheckoutOptionsQuery = () => {
  return useQuery({
    queryKey: [OPTIONS_QUERY_KEYS.CHECKOUT],
    queryFn: optionsApiService.getCheckoutOptions,
    staleTime: Infinity,
  });
};
